/** @format */
import { Image } from '@toucan/common/contentful/types';

import { RichText, UrlSlugParamsType } from '@toucan/client/core/contentful';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum EntryType {
    INLINE = 'inline',
    BLOCK = 'block',
    HYPERLINK = 'hyperlink',
}

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum LandingPageHeroRenderType {
    CURVE = 'CURVE',
    MAIN_MIDNIGHT = 'MAIN_MIDNIGHT',
    MAIN_MIDNIGHT_GRADIENT = 'MAIN_MIDNIGHT_GRADIENT',
    MAIN_SUSTAINABILITY_GRADIENT = 'MAIN_SUSTAINABILITY_GRADIENT',
}

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type LandingPageContent = {
    content: RichText | null;
};

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type LandingPageData = UrlSlugParamsType & {
    __typename: string;
    sys: {
        id: string;
    };
    title: string;
    description: string;
    heroImage: Image | null;
    heroButtonText: string | null;
    heroButtonLink: string | null;
    heroRenderType: LandingPageHeroRenderType;
    seoTitle: string | null;
    seoDescription: string | null;
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    disableSearchEngineIndexing: boolean | null;
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    enableTrustPilotWidgetInHero: boolean | null;
};

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type LandingPageDataResponse = {
    landingPageCollection?: {
        items?: LandingPageData[];
    };
};

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type LandingPageContentResponse = {
    landingPageCollection?: {
        items?: LandingPageContent[];
    };
};
